import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useIntervalOption, useWidgets } from 'modules/Dashboard/Widgets/Hooks';
import { useCompletionRate } from 'modules/Dashboard/Widgets/CompletionRate/Hooks';

import { CompletionRate } from './CompletionRate.component';
import { UsersWidgetPlaceholder } from 'modules/Dashboard/Widgets/Users/Common';
import { WidgetSettings } from 'modules/Dashboard/Widgets/Common';
import { MOCKED_DATA } from 'modules/Dashboard/Widgets/CompletionRate/CompletionRate.utils';

export const CompletionRateContainer = ({ widget, isMock }) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const { intervalOption, setIntervalOption } = useIntervalOption({
    defaultOption: widget?.settings?.default_option || '7',
  });

  const { fetchCompletionRate, completionRate } = useCompletionRate({
    widgetType: widget?.type,
  });
  const { saveWidgetSettings, removeActiveWidget } = useWidgets();

  useEffect(() => {
    if (isMock) return;

    fetchCompletionRate(intervalOption);
  }, []);

  const handleChangeIntervalOption = (option) => {
    if (isMock) return;

    setIntervalOption(option);
    fetchCompletionRate(option);
  };

  if (completionRate?.loading) {
    return <UsersWidgetPlaceholder widget={widget} />;
  }

  if (isSettingsOpen) {
    return (
      <WidgetSettings
        widget={widget}
        onSave={saveWidgetSettings}
        onClose={() => setIsSettingsOpen(false)}
        onRemoveWidget={removeActiveWidget}
      />
    );
  }

  return (
    <CompletionRate
      widget={widget}
      data={isMock ? MOCKED_DATA : completionRate?.data}
      intervalOption={intervalOption}
      onChangeIntervalOption={handleChangeIntervalOption}
      onOpenSettings={() => setIsSettingsOpen(true)}
      isMock={isMock}
    />
  );
};

CompletionRateContainer.propTypes = {
  widget: PropTypes.object,
  isMock: PropTypes.bool,
};
